import { orange, red } from '@material-ui/core/colors';

import { BarChart } from '@mui/x-charts/BarChart';
import { ScoreWithFixAndNoFix } from '@internal/ui-common';

export type VulnerabilitiesBarChartScale = {
  yAxis: {
    min: number;
    max: number;
  };
};

export const VulnerabilitiesBarChart = ({
  score,
  scale,
}: {
  score: ScoreWithFixAndNoFix;
  scale?: VulnerabilitiesBarChartScale;
}) => {
  const { min: yAxisMin, max: yAxisMax } = scale?.yAxis ?? {};
  const yAxisScaleMin = yAxisMin ?? 0;
  const yAxisScaleMax =
    yAxisMax ??
    Math.max(
      score.red.fix,
      score.red.noFix,
      score.orange.fix,
      score.orange.noFix,
    );
  return (
    <BarChart
      colors={[red[300], orange[300]]}
      xAxis={[
        { scaleType: 'band', data: ['Fix available', 'No fix available'] },
      ]}
      yAxis={[
        {
          scaleType: 'linear',
          min: yAxisScaleMin,
          max: yAxisScaleMax + 100, // Adding extra 100 so that bars don't touch the top of chart.
        },
      ]}
      series={[
        { data: [score.red.fix, score.red.noFix], label: 'CRITICAL' },
        { data: [score.orange.fix, score.orange.noFix], label: 'HIGH' },
      ]}
      width={500}
      height={200}
    />
  );
};
